export default __webpack_public_path__ + "static/media/person.fa484f35.svg";